import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/dosage";

export const saveDosage = dosage => axios.post(API_PATH + "/save", dosage);

export const getDosageById = dosageId => axios.get(API_PATH + "/getbyid/" + dosageId);

export const pagingDosage = (searchObject) => axios.post(API_PATH + "/paging-dosage", searchObject);

export const deleteDosage = dosageId => axios.delete(API_PATH + "/mark-delete/" + dosageId);

export const getAllDosage = () => axios.get(API_PATH + "/get-all");

